import { graphql } from '@/graphql/generated/platform';

export const billsQuery = graphql(`
  query BillsQuery(
    $limit: Int!
    $offset: Int!
    $where: BillsBoolExp!
    $orderBy: [BillsOrderByExp!]!
  ) {
    bills(limit: $limit, offset: $offset, where: $where, order_by: $orderBy) {
      id
      name
      billNumber
      billTotal
      status
      periodStart
      periodEnd
      recalculatedAt
      createdAt
      accountId
      account {
        id
        name
      }
      location {
        id
        name
      }
      holds {
        id
        billId
        reason
        createdAt
        updatedAt
      }
    }
    billsAggregate(filter_input: { where: $where }) {
      _count
    }
  }
`);
